import { Button, Checkbox, Col, Modal, Row } from "antd";
import { useState } from "react";
import { rememberCookieConsent } from "../../utils/storage";
import styles from "./CookieModal.module.scss";
import cookie from "./images/cookie.svg";

// cookie modal
const CookieModal = ({ showModal, setShowModal }) => {
  const [showDetails, setShowDetails] = useState(false);
  const onChange = (checkedValues) => {
    console.log("checked = ", checkedValues);
  };

  // whichever button ends the banner, the answer is recorded - the visitor has
  // made their choice and should not be asked again on this browser
  const handleClose = () => {
    setShowModal(false);
    rememberCookieConsent();
  };

  return (
    <Modal
      centered
      open={showModal}
      footer={null}
      onCancel={handleClose}
      closable={false}
      bodyStyle={{
        padding: 15,
      }}
    >
      <div className={styles.upper_part}>
        <img src={cookie} alt="cookie" />
        <h3>Cookies</h3>
        <h4>Optional Settings</h4>
        <div>
          We use various techniques on our website in order to offer you the
          best possible experience. This includes data processing that is
          technically necessary for the provision of the website and our mobile
          apps and its functionalities, as well as other techniques that are
          used for convenient website settings, for creating anonymous
          statistics or for displaying personalized (advertising) content.
          Further information, including your{" "}
          <a href="/">right of withdrawal </a> at any time,can be found in our{" "}
          <a href="/">data protection principles</a>. You can find our imprint{" "}
          <a href="/">here</a>.
        </div>

        <div className={styles.btn_group}>
          <Button type="primary" onClick={handleClose}>
            Agree
          </Button>
          <Button type="default" onClick={() => setShowDetails(!showDetails)}>
            Modify
          </Button>
          <Button type="default" onClick={handleClose}>
            Disagree
          </Button>
        </div>
      </div>
      <div
        className={styles.details}
        onClick={() => {
          setShowDetails(!showDetails);
        }}
      >
        {showDetails ? "Hide details" : "Show details"}
      </div>

      {showDetails && (
        <>
          <Checkbox.Group
            style={{
              width: "100%",
            }}
            onChange={onChange}
          >
            <Row>
              <Col span={12}>
                <Checkbox value="Necessary">Necessary</Checkbox>
              </Col>
              <Col span={12}>
                <Checkbox value="Statistics">Statistics</Checkbox>
              </Col>
              <Col span={12}>
                <Checkbox value="Preferences">Preferences</Checkbox>
              </Col>
              <Col span={12}>
                <Checkbox value="Marketing">Marketing</Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
          <div className={styles.agree_btn}>
            <Button type="primary" onClick={handleClose}>
              Agree to detail selection
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default CookieModal;
